import PagePopopCloseButton from "components/page-components/PagePopopCloseButton";
import { useState } from "react";
import successIcon from "assets/img/icons/success-green-big.svg";
import failIcon from "assets/img/icons/icon-warning.svg";
import ModalWindow from "components/ModalWindow";

const ProfileResetPassword = ({ resetPassword, playSound }) => {
  const [isLoading, setIsLoading] = useState(false);

  const [step, setStep] = useState("closed");

  const close = () => {
    playSound();
    setStep("closed");
  };

  return (
    <>
      <button
        type="button"
        className={`profile-form__row-button ${
          isLoading === true ? "loading" : ""
        }`}
        disabled={isLoading}
        onClick={() => {
          playSound();
          resetPassword(setStep, setIsLoading)
        }}
      >
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.66634 10.5H4.99967C4.0792 10.5 3.33301 11.2462 3.33301 12.1667C3.33301 13.0872 4.0792 13.8334 4.99967 13.8334H13.333C14.2535 13.8334 14.9997 14.5796 14.9997 15.5C14.9997 16.4205 14.2535 17.1667 13.333 17.1667H9.99967M12.4997 10.5L9.99967 10.5V8L14.9997 3L17.4997 5.49995L12.4997 10.5Z"
            stroke="#AAABAB"
            strokeWidth="1.6"
            strokeLinecap="square"
          />
        </svg>
        Edit
      </button>

      {step !== "closed" && (
        <ModalWindow close={close}>
          <div
            className="modal-window__wrapper"
            onClick={(e) => e.stopPropagation()}
          >
            <PagePopopCloseButton close={close} />
            {step === "success" && (
              <>
                <header className="modal-window__header">
                  <img
                    src={successIcon}
                    className="modal-window__icon"
                    alt=""
                  />
                  <h5 className="modal-window__title">Success!</h5>
                  <p className="modal-window__info">
                    Email was received to you email
                  </p>
                </header>
                <footer className="modal-window__footer">
                  <button
                    className="modal-window__footer-submit"
                    onClick={close}
                  >
                    Done
                  </button>
                </footer>
              </>
            )}
            {step === "fail" && (
              <>
                <header className="modal-window__header">
                  <img src={failIcon} className="modal-window__icon" alt="" />
                  <h5 className="modal-window__title">Oops...</h5>
                  <p className="modal-window__info">
                    Something went wrong. Please try again later
                  </p>
                </header>
                <footer className="modal-window__footer">
                  <button
                    className="modal-window__footer-submit"
                    onClick={close}
                  >
                    Done
                  </button>
                </footer>
              </>
            )}
          </div>
        </ModalWindow>
      )}
    </>
  );
};

export default ProfileResetPassword;
